import { useEffect } from "react";
import { useLocation } from "react-router";
import { trackPageView } from "./amplitude";
import { recordPathname } from "./productEvents";

/** Tracks route changes as Amplitude page-view events (client-only). */
export function useAmplitudeRouterTracking(): void {
  const { pathname, search } = useLocation();

  useEffect(() => {
    recordPathname(pathname);
    trackPageView(`${pathname}${search}`);
  }, [pathname, search]);
}
